// extracted by mini-css-extract-plugin
module.exports = {"listItem":"KeyListItem_listItem__jtbcH","checkbox":"KeyListItem_checkbox__1KehK","color":"KeyListItem_color__2sztJ","label":"KeyListItem_label__1agaZ"};